import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as customerApi from "../api/customer";
import {
  sync,
  updateEventSourceId,
  updateBalance,
  updateDebt,
  selectRecent,
  setOnlineOrder,
  selectEventSourceId,
  addTransactions,
  updateOnlineOrderStatus,
  updateTierInfo,
  selectCurrent,
} from "../store/customer";
import { selectAccessToken } from "../store/auth";

export function useSubscribeUpdates() {
  const [eventSource, setEventSource] = useState(null);
  const customer = useSelector(selectCurrent);
  const accessToken = useSelector(selectAccessToken);
  const recent = useSelector(selectRecent);
  const eventSourceId = useSelector(selectEventSourceId);
  const dispatch = useDispatch();

  const initEventSource = async () => {
    const { id } = await customerApi.initUpdatesSubscription(accessToken);
    dispatch(updateEventSourceId(id));
    const es = await customerApi.subscribeToUpdates(id);

    es.addEventListener("CustomerBalanceUpdate", (event) => {
      dispatch(updateBalance(JSON.parse(event.data)));
    });
    es.addEventListener("CustomerDebtUpdate", (event) => {
      dispatch(updateDebt(JSON.parse(event.data)));
    });
    es.addEventListener("CustomerOnlineOrderUpdate", (event) => {
      dispatch(setOnlineOrder(JSON.parse(event.data)));
    });
    es.addEventListener("CustomerTransactionsUpdate", (event) => {
      dispatch(addTransactions(JSON.parse(event.data)));
    });
    es.addEventListener("CustomerOnlineOrderStatusUpdate", (event) => {
      dispatch(updateOnlineOrderStatus(JSON.parse(event.data)));
    });
    es.addEventListener("CustomerTierInfoUpdate", (event) => {
      dispatch(updateTierInfo(JSON.parse(event.data)));
    });
    es.addEventListener("FullCustomerUpdate", (event) => {
      dispatch(sync(JSON.parse(event.data)));
    });
    if (customer != null) {
      customerApi.subscribeToCustomerUpdates(accessToken, id, [customer.id]);
    }
    return es;
  };

  useEffect(() => {
    const inner = async () => {
      if (eventSource == null) {
        setEventSource(await initEventSource());
      } else {
        customerApi.subscribeToCustomerUpdates(
          accessToken,
          eventSourceId,
          recent.map((c) => c.id),
        );
      }
    };
    inner().catch(console.error);
  }, [customer?.id]);
}
